export interface DynamicParam {
  key: string;
  value: string;
}

export const DYNAMIC_PARAMS_FIELD = 'config.dynamicParams';

export function withRequiredVariableRows(
  params: DynamicParam[] | undefined,
  requiredVariables: string[]
): DynamicParam[] {
  const rows = params ?? [];
  const existingKeys = new Set(rows.map((row) => row.key));
  const missingRows = requiredVariables
    .filter((variable) => !existingKeys.has(variable))
    .map((key) => ({ key, value: '' }));
  return [...rows, ...missingRows];
}
